import React, { useState } from "react";
import { cva } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const inputClasses = cva(
  "transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed",
  {
    variants: {
      variant: {
        primary: "focus:ring-blue-500",
        secondary: "focus:ring-gray-500",
        outline: "focus:ring-blue-500",
      },
      size: {
        small: "text-sm px-2 py-1",
        medium: "text-base px-3 py-2",
        large: "text-lg px-4 py-3",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "medium",
    },
  }
);

const EditText = ({
  // Required parameters with defaults
  placeholder = "Enter your mail",
  // text_font_size = "20",
  text_font_family = "Sora",
  text_font_weight = "400",
  text_line_height = "26px",
  text_text_align = "left",
  text_color = "#ffffff7f",
  border_border = "1px solid #ffffff",
  border_border_radius = "30px",

  // Optional parameters (no defaults)
  layout_width,
  padding,
  position,

  // Standard React props
  variant,
  size,
  disabled = false,
  className,
  value,
  defaultValue,
  onChange,
  onFocus,
  onBlur,
  type = "text",
  ...props
}) => {
  const [inputValue, setInputValue] = useState(defaultValue || "");

  // Safe validation for optional parameters
  const hasValidWidth =
    layout_width &&
    typeof layout_width === "string" &&
    layout_width?.trim() !== "";
  const hasValidPadding =
    padding && typeof padding === "string" && padding?.trim() !== "";
  const hasValidPosition =
    position && typeof position === "string" && position?.trim() !== "";

  // Build optional Tailwind classes
  const optionalClasses = [
    hasValidWidth ? `w-[${layout_width}]` : "w-full",
    hasValidPadding ? `p-[${padding}]` : "",
    hasValidPosition ? position : "",
  ]
    ?.filter(Boolean)
    ?.join(" ");

  // Build inline styles for required parameters
  const inputStyles = {
    // fontSize: text_font_size ? `${text_font_size}px` : "20px",
    fontFamily: text_font_family || "Sora",
    fontWeight: text_font_weight || "400",
    lineHeight: text_line_height || "26px",
    textAlign: text_text_align || "center",
    color: text_color || "#ffffff7f",
    border: border_border || "1px solid #ffffff",
    borderRadius: border_border_radius || "30px",
    backgroundColor: "transparent",
  };

  // Handle input change
  const handleChange = (event) => {
    const newValue = event?.target?.value;
    setInputValue(newValue);
    if (typeof onChange === "function") {
      onChange(event);
    }
  };

  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value !== undefined ? value : inputValue}
      disabled={disabled}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={onBlur}
      style={inputStyles}
      className={twMerge(
        inputClasses({ variant, size }),
        optionalClasses,
        className
      )}
      aria-disabled={disabled}
      {...props}
    />
  );
};

export default EditText;
